var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-container"},[_vm._t("topContent"),_c('div',{staticClass:"tit-bar"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"button-bar"},[_vm._t("button")],2)]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }